import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FleetMockStore } from '../mock/fleet-mock.store';
import { FleetSimulatorService } from '../mock/fleet-simulator.service';
import { FleetVehicle } from '../mock/models/fleet.models';

@Component({
  selector: 'app-fleet-command-center',
  templateUrl: './fleet-command-center.component.html',
  styleUrl: './fleet-command-center.component.css',
})
export class FleetCommandCenterComponent implements OnInit, OnDestroy {
  vehicles: FleetVehicle[] = [];
  selectedId: string | null = null;

  panelCollapsed = false;

  private sub?: Subscription;

  constructor(
    private readonly store: FleetMockStore,
    private readonly simulator: FleetSimulatorService,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.simulator.start();
    this.sub = this.store.fleet$.subscribe((fleet) => {
      this.vehicles = fleet;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.simulator.stop();
  }

  // Contadores por semáforo
  get movingCount(): number {
    return this.vehicles.filter((v) => v.status_live === 'MOVING').length;
  }
  get stoppedCount(): number {
    return this.vehicles.filter((v) => v.status_live === 'STOPPED').length;
  }
  get idleCount(): number {
    return this.vehicles.filter((v) => v.status_live === 'IDLE').length;
  }

  onSelect(v: FleetVehicle): void {
    this.selectedId = v.id;
  }

  togglePanel(): void {
    this.panelCollapsed = !this.panelCollapsed;
  }
}
